<template>
	<div>
		<tableBox  :url="'/Flat/SelUserfflineTrainings'" :exportUrl="'/Flat/ExportSelUserfflineTrainings'"  :ifState="true"  :ifSearch="true"  :columns="columns"></tableBox>
	</div>
</template>

<script>
	import tableBox from '../../../components/tableBox.vue'
	export default {
		name:'/core/training',
		components: {
			tableBox
		},
		data() {
			return {

				columns: [{
						title: '培训项目',
						dataIndex: 'title',
						key: 'title',
						scopedSlots: {
							customRender: 'trainTitles'
						},
					},
					{
						title: '平台',
						key: 'labname',
						dataIndex: 'labname',
						
						aligh:'center'
					},
					{
						title: '培训时间',
						dataIndex: 'regDate',
						key: 'regDate',
						scopedSlots: {
							customRender: 'regDate'
						},
					},
					{
						title: '培训地点',
						dataIndex: 'location',
						key: 'location'

					},
					
					// {
					// 	title: '报名人数',
					// 	key: 'regCount',
					// 	dataIndex: 'regCount',
					// },
					{
						title: '报名时间',
						key: 'createTime',
						dataIndex: 'createTime',
						scopedSlots: {
							customRender: 'createTime'
						},

					},
					{
						title: '签到时间',
						dataIndex: 'checkInTime',
						key: 'checkInTime'
					
					},
					{
						title: '签退时间',
						dataIndex: 'checkOutTime',
						key: 'checkOutTime'
					
					},
					
					{
						title: '状态',
						key: 'pxState',
						dataIndex: 'pxState',
						scopedSlots: {
							customRender: 'pxState'
						},
						aligh:'center'
					},
					{
						title: '结果',
						key: 'state',
						dataIndex: 'state',
						scopedSlots: {
							customRender: 'state'
						},
						aligh:'center'
					},
					// {
					// 	title: '操作',
					// 	dataIndex: 'examOperation',
					// 	scopedSlots: {
					// 		customRender: 'examOperation'
					// 	},
					// },
				]
			}
		}
	};
</script>

<style>
</style>
